// extracted by mini-css-extract-plugin
export default {"intoduction":"introduction_intoduction__5fhLL","cursor":"introduction_cursor__TkKtU","blink":"introduction_blink__Z0wlH","fadeIn":"introduction_fadeIn__+2JRM"};